export const ORG_INACTIVE_NOTIFICATIONS_CREATE_FORM = 'ORG_INACTIVE_NOTIFICATIONS_CREATE_FORM'
export const ORG_INACTIVE_NOTIFICATIONS_EDIT_FORM = 'ORG_INACTIVE_NOTIFICATIONS_EDIT_FORM'
